"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionToggler = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const reactstrap_1 = require("reactstrap");
class VersionToggler extends React.Component {
    constructor() {
        super(...arguments);
        this.swap = () => {
            if (this.props.container.current === 'valid' && this.props.container.draft) {
                this.props.container.active = this.props.container.draft;
                this.props.container.current = 'draft';
            }
            else if (this.props.container.valid) {
                this.props.container.active = this.props.container.valid;
                this.props.container.current = 'valid';
            }
        };
    }
    render() {
        const { endpointStore, container, className, style } = this.props;
        if (!endpointStore || !endpointStore.modeAdmin || !container.draft) {
            return null;
        }
        return (React.createElement(reactstrap_1.Button, { className: className, style: style, color: container.current === 'valid' ? 'info' : 'warning', onClick: this.swap, disabled: !container.valid, size: "sm" },
            React.createElement("i", { className: "mdi mdi-swap-horizontal" })));
    }
}
__decorate([
    mobx_1.action
], VersionToggler.prototype, "swap", void 0);
exports.VersionToggler = VersionToggler;
exports.default = mobx_react_1.inject('endpointStore')(mobx_react_1.observer(VersionToggler));
